<template>
<div>
    <zm-table v-loading="loading"
        :data="tableData.length ? tableData : [{}]"
        id="subscriber-table"
        border :show-overflow-tooltip="true" @selection-change="handleSelectPub">
        <zm-table-column type="selection" width="55"></zm-table-column>
        <zm-table-column label="IP" prop="ip"></zm-table-column>
        <zm-table-column label="RequestIp" prop="requestIp" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="HostName" prop="hostName" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="ClientId" prop="clientId"></zm-table-column>
        <zm-table-column prop="userName" label="User Name" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column prop="secretType" label="Secret Type" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="Status" prop="status">
            <!-- eslint-disable-next-line -->
            <template slot="header" slot-scope="scope">
                <zm-dropdown trigger="click" @command="handleStatus">
                    <span class="zm-dropdown-link">
                        {{ filter.status || 'Status' }}<i class="zm-icon-down zm-icon--right"></i>
                    </span>
                    <zm-dropdown-menu slot="dropdown">
                        <zm-dropdown-item command="">All</zm-dropdown-item>
                        <zm-dropdown-item command="STARTED">STARTED</zm-dropdown-item>
                        <zm-dropdown-item command="WORKING">WORKING</zm-dropdown-item>
                        <zm-dropdown-item command="ERROR">ERROR</zm-dropdown-item>
                        <zm-dropdown-item command="SHUTDOWN">SHUTDOWN</zm-dropdown-item>
                        <zm-dropdown-item command="ONHOLD">ONHOLD</zm-dropdown-item>
                        <zm-dropdown-item command="STOPPED">STOPPED</zm-dropdown-item>
                        <zm-dropdown-item command="PAUSED">PAUSED</zm-dropdown-item>
                        <zm-dropdown-item command="UNKNOWN">UNKNOWN</zm-dropdown-item>
                        <zm-dropdown-item command="INITIAL">INITIAL</zm-dropdown-item>
                    </zm-dropdown-menu>
                </zm-dropdown>
            </template>
            <template slot-scope="scope">
                {{ scope.row.status }}
                <zm-tooltip
                    placement="top-start"
                    v-if="scope.row.status === 'ERROR'">
                    <div slot="content">
                        <div v-for="item in scope.row.errorMessage.split('\n\t')" :key="item">{{item}}</div>
                    </div>
                    <zm-button size="small" class="btn-contain" type="icon" icon="zm-icon-warning"></zm-button>
                </zm-tooltip>
            </template>
        </zm-table-column>
        <zm-table-column label="HAStatus" prop="haStatus">
            <!-- eslint-disable-next-line -->
            <template slot="header" slot-scope="scope">
                <zm-dropdown trigger="click" @command="handleHaStatus">
                    <span class="zm-dropdown-link">
                        {{ filter.haStatus || 'HAStatus' }}<i class="zm-icon-down zm-icon--right"></i>
                    </span>
                    <zm-dropdown-menu slot="dropdown">
                        <zm-dropdown-item command="">ALL</zm-dropdown-item>
                        <zm-dropdown-item command="MASTER">MASTER</zm-dropdown-item>
                        <zm-dropdown-item command="BACKUP">BACKUP</zm-dropdown-item>
                        <zm-dropdown-item command="UNAVAILABLE">UNAVAILABLE</zm-dropdown-item>
                    </zm-dropdown-menu>
                </zm-dropdown>
            </template>
        </zm-table-column>
        <zm-table-column label="dcName" prop="dcName"></zm-table-column>
        <zm-table-column label="Client Version" prop="clientVersion"></zm-table-column>
        <zm-table-column label="Client Param" prop="clientParam">
            <template slot-scope="scope">
                <zm-tooltip placement="right" v-if="scope.row.clientParametersResult">
                  <div slot="content">
                    <p v-for="(value, index) in scope.row.clientParametersResult" :key="index">{{ index }}: {{
                        value
                      }}</p>
                  </div>
                  <zm-tag size="medium" type="">{{ scope.row.clientParametersResult.name }}</zm-tag>
                </zm-tooltip>
                <span v-else></span>
            </template>
        </zm-table-column>
        <zm-table-column label="CreatedTime" prop="createdTime" :formatter="setTime"></zm-table-column>
        <zm-table-column label="Record Time" prop="recordTime" :formatter="setTime" :show-overflow-tooltip="true"></zm-table-column>
        <zm-table-column label="ModifiedTime" prop="modifiedTime" :formatter="setTime"></zm-table-column>
        <zm-table-column width="100px" align="center" fixed="right">
            <!-- eslint-disable-next-line -->
            <template slot="header" slot-scope="scope">
                <zm-button size="small" class="btn-contain" type="icon" title="batch seet publisher"
                icon="zm-icon-settings" @click="showBatchSetPub()" :disabled="!selectedPubIds.length"></zm-button>
                <zm-button size="small" class="btn-contain" type="icon" title="batch delete publisher"
                icon="zm-icon-delete" @click="batchDeletePub(scope)" :disabled="!selectedPubIds.length"></zm-button>
            </template>
            <template slot-scope="scope">
                <zm-button size="small" class="btn-contain" type="icon" title="change publisher status" :loading="scope.row.editloading"
                icon="zm-icon-edit" @click="changePublisherStatus(scope.row)"></zm-button>
                <zm-button size="small" class="btn-contain" type="icon" title="refresh publisher"
                icon="zm-icon-refresh" @click="refreshPub(scope.row)"></zm-button>
            </template>
        </zm-table-column>
    </zm-table>
    <div style="text-align: center" class="pagination-wrap">
        <zm-pagination @current-change="paginationChange"
            @size-change="handleSizeChange"
            :current-page.sync="pageable.page"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size="pageable.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageable.total">
        </zm-pagination>
    </div>
    <zm-dialog title="Publisher Setting" :visible.sync="publisherVisible" :append-to-body="true" width="450px">
        <zm-form :model="publisherForm" label-position="left" ref="form">
            <zm-form-item label="status" label-width="100px">
                <div slot="label">
                    <tip label="status" id="topic-publisher-status"></tip>
                </div>
                <zm-select size="small" v-model="publisherForm.settingStatus">
                    <zm-option v-for="item in options" :key="item.value"
                    :disabled="item.disabled"
                    :label="item.value" :value="item.value"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item label="createdTime" label-width="100px">
                <div slot="label">
                    <tip label="createdTime" id="topic-publisher-createdTime"></tip>
                </div>
                <zm-date-picker size="small" type="datetime" v-model="publisherForm.settingCreatedTime" readonly></zm-date-picker>
            </zm-form-item>
            <zm-form-item label="modifiedTime" label-width="100px">
                <div slot="label">
                    <tip label="modifiedTime" id="topic-publisher-modifiedTime"></tip>
                </div>
                <zm-date-picker size="small" type="datetime" v-model="publisherForm.settingModifiedTime" readonly></zm-date-picker>
            </zm-form-item>
        </zm-form>
        <div slot="footer" class="dialog-footer">
            <zm-button size="small" @click="publisherVisible = false">Cancel</zm-button>
            <zm-button size="small" type="primary" @click="resetPub()" :loading="resetLoading">Reset</zm-button>
            <zm-button size="small" type="primary" @click="savePublisher()" :loading="saveLoading">Submit</zm-button>
        </div>
    </zm-dialog>
    <zm-dialog title="Subscriber Batch Settings" :visible.sync="batchVisible" :append-to-body="true" width="450px">
        <zm-form :model="batchForm" label-position="left" ref="form">
            <zm-form-item label="status" label-width="100px">
                <div slot="label">
                    <tip label="status" id="topic-publisher-status"></tip>
                </div>
                <zm-select size="small" v-model="batchForm.settingStatus">
                    <zm-option v-for="item in options" :key="item.value"
                    :label="item.value" :value="item.value"></zm-option>
                    <zm-option label="RESTART" value="RESTART"></zm-option>
                </zm-select>
            </zm-form-item>
        </zm-form>
        <div slot="footer" class="dialog-footer">
            <zm-button size="small" @click="batchVisible = false">Cancel</zm-button>
            <zm-button size="small" type="primary" @click="batchReset()" :loading="resetLoading">Reset</zm-button>
            <zm-button size="small" type="primary" @click="saveBatch()" :loading="saveLoading">Submit</zm-button>
        </div>
    </zm-dialog>
</div>
</template>
<script>
import { getTopicPublisher, batchDeletePub, updateProducer, refreshProducer, batchSetPublishers } from '../../api/index'
import tip from 'components/ToolTip/index'
export default {
    name: 'publisher',
    components: {
        tip
    },
    data () {
        return {
            loading: false,
            resetLoading: false,
            saveLoading: false,
            list: [],
            filter: {
                status: '',
                haStatus: ''
            },
            selectedPubIds: [],
            publisherForm: {
                id: '',
                clientVersion: '',
                ip: '',
                clientId: '',
                settingStatus: '',
                settingCreatedTime: '',
                settingModifiedTime: '',
                status: '',
                topicId: '',
                userId: ''
            },
            publisherVisible: false,
            pageable: {
                total: 0,
                page: 1,
                size: 10
            },
            batchVisible: false,
            batchForm: {
                ids: [],
                settingStatus: ''
            },
            options: [
                // {
                //     disabled: true,
                //     value: 'INITIAL'
                // },
                {
                    disabled: false,
                    value: 'FORBIDDEN'
                },
                {
                    disabled: false,
                    value: 'ALLOWED'
                }
            ]
        }
    },
    props: ['topicId'],
    mounted () {
        this.fetchData()
    },
    computed: {
        tableData () {
            const { status, haStatus } = this.filter
            if (status && haStatus) {
                return this.list.filter(data => {
                    return data.status === status && data.haStatus === haStatus
                })
            } else if (status) {
                return this.list.filter(data => {
                    return data.status === status
                })
            } else if (haStatus) {
                return this.list.filter(data => {
                    return data.haStatus === haStatus
                })
            }
            return this.list
        }
    },
    methods: {
        showBatchSetPub () {
            this.batchForm.ids = JSON.parse(JSON.stringify(this.selectedPubIds))
            this.batchForm.settingStatus = 'INITIAL'
            this.batchVisible = true
        },
        saveBatch (isRefresh) {
            if (isRefresh) {
                this.resetLoading = true
            } else {
                this.saveLoading = true
            }
            batchSetPublishers(this.batchForm).then(response => {
                this.$message({
                    message: 'Batch set publishers success!',
                    type: 'success'
                })
                this.resetLoading = false
                this.saveLoading = false
                this.batchVisible = false
            }).catch(() => {
                this.resetLoading = false
                this.saveLoading = false
            })
        },
        batchReset () {
            this.$confirm('This will reset the publishers. Continue?', 'Warning', {
                confirmButtonText: 'Reset',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.batchForm.settingStatus = 'INITIAL'
                this.saveBatch(true)
            }).catch(() => {
                this.resetLoading = false
                this.saveLoading = false
                this.$message({
                    type: 'info',
                    message: 'Reset canceled'
                })
            })
        },
        fetchData () {
            this.loading = true
            getTopicPublisher(this.topicId, this.pageable.size, this.pageable.page - 1, this.filter.status, this.filter.haStatus).then(res => {
                const { content, pageable: { page, size }, total } = res
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.list.map(item => {
                    item.editloading = false
                })
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSelectPub (val) {
            this.selectedPubIds = []
            val.map(item => {
                this.selectedPubIds.push(item.id)
            })
        },
        batchDeletePub (row) {
            const ids = this.selectedPubIds
            this.loading = true
            this.$confirm('This will permanently batch delete the publishers. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                batchDeletePub(ids).then(response => {
                    this.loading = false
                    this.selectedPubIds = []
                    this.$message({
                        message: 'Delete publishers success!',
                        type: 'success'
                    })
                    this.fetchData()
                    // this.$emit('refreshPublisherList')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        refreshPub (row) {
            this.loading = true
            refreshProducer(row.id, row.clientId, this.topicId, row.userId).then(response => {
                this.loading = false
                this.list.map(pub => {
                    if (pub.id === row.id) {
                        if (response.errorMessage) {
                            row.errorMessage = response.errorMessage
                        }
                        for (var key in response) {
                            if (row[key]) {
                                row[key] = response[key]
                            } else if (key === 'haStatus') {
                                row.haStatus = response[key]
                            }
                        }
                    }
                })
            }).catch(() => {
                this.loading = false
            })
        },
        doChangePublisherSettings (data, isRefresh) {
            if (isRefresh) {
                this.resetLoading = true
            } else {
                this.saveLoading = true
            }
            this.$confirm('Sure to change status to ' + data.settingStatus + '?', 'Warning', {
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                updateProducer(data).then(response => {
                    this.fetchData()
                    // this.$emit('refreshPublisherList')
                    this.$message({
                        message: 'Change status success!',
                        type: 'success'
                    })
                    this.resetLoading = false
                    this.saveLoading = false
                    this.publisherVisible = false
                }).catch(() => {
                    this.resetLoading = false
                    this.saveLoading = false
                })
            }).catch(() => {
                this.resetLoading = false
                this.saveLoading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        changePublisherStatus (row) {
            row.editloading = true
            refreshProducer(row.id, row.clientId, this.topicId, row.userId).then(response => {
                const { clientVersion, ip, clientId, settingStatus, status, topicId, userId, settingCreatedTime, settingModifiedTime } = response
                this.publisherForm.id = row.id
                this.publisherForm.clientVersion = clientVersion
                this.publisherForm.ip = ip
                this.publisherForm.clientId = clientId
                this.publisherForm.settingStatus = settingStatus
                this.publisherForm.status = status
                this.publisherForm.topicId = topicId
                this.publisherForm.userId = userId
                this.publisherForm.settingCreatedTime = settingCreatedTime
                this.publisherForm.settingModifiedTime = settingModifiedTime
                this.publisherVisible = true
                row.editloading = false
            }).catch(() => {
                row.editloading = false
            })
        },
        resetPub () {
            this.$confirm('This will reset the publisher. Continue?', 'Warning', {
                confirmButtonText: 'Reset',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.publisherForm.settingStatus = 'INITIAL'
                this.savePublisher(true)
            }).catch(() => {
                this.resetLoading = false
                this.saveLoading = false
                this.$message({
                    type: 'info',
                    message: 'Reset canceled'
                })
            })
        },
        savePublisher (isRefresh) {
            const { id, clientVersion, ip, clientId, settingStatus, status, topicId, userId } = this.publisherForm
            const data = { id, clientVersion, ip, clientId, settingStatus, status, topicId, userId }
            this.doChangePublisherSettings(data, isRefresh)
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        },
        paginationChange () {
            this.fetchData()
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        handleStatus (command) {
            this.filter.status = command
            this.fetchData()
        },
        handleHaStatus (command) {
            this.filter.haStatus = command
            this.fetchData()
        }
    }
}
</script>
